import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../config";

const msal = new PublicClientApplication(msalConfig);

type Scopes = {
  diningApi: string;
};

export const scopes: Scopes = {
  diningApi: msalConfig.auth?.clientId + "/.default",
};

export default msal;
